import WhatWeDo from './WhatWeDo.jsx';

export default WhatWeDo;
